import { render, staticRenderFns } from "./TariffBox.vue?vue&type=template&id=2bd17249&scoped=true&"
import script from "./TariffBox.vue?vue&type=script&lang=js&"
export * from "./TariffBox.vue?vue&type=script&lang=js&"
import style0 from "./TariffBox.vue?vue&type=style&index=0&id=2bd17249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd17249",
  null
  
)

export default component.exports